import { ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';

export const codetableOptionsIds: CodetableOptionsIds = {
  [ScreenPicker.likelihood]: 169,
  [ScreenPicker.recurrence]: 130,
  [ScreenPicker.severity]: 134,
  [ScreenPicker.defaultUom]: 338,
  [ScreenPicker.defaultUomType]: 334,
  [ScreenPicker.uom]: 338,
  [ScreenPicker.uomSetValueType]: 334,
  [ScreenPicker.uomSetIndicatorValue]: 338,
  [ScreenPicker.uomSetIndicatorValueType]: 334,
  [ScreenPicker.checkedCode]: 446,
  [ScreenPicker.uncheckedCode]: 446,
  [ScreenPicker.referenceCodeCategory]: 20,
  [ScreenPicker.uomTypeTo]: 334,
  [ScreenPicker.uomTypeFrom]: 334,
  [ScreenPicker.uomFrom]: 338,
  [ScreenPicker.uomTo]: 338,
  [ScreenPicker.uomConversionType]: 397,
  [ScreenPicker.measurementSystem]: 335,
  [ScreenPicker.consequenceType]: 109,
  [ScreenPicker.unitOfMeasure]: 338
};

export const CheckBoxReferenceTypeId = 9;

export type CodetableOptionsIds = {
  [key in ScreenPicker]?: number;
};

export const codeColourId = 377;
export const referenceTypeId = 20;
